<div class="notifications-wrapper" *transloco="let t">
  <div class="header-wrapper">
    <p class="bold messages-wrapper">
      {{ t('app.profile.notificationsHeader') }}
      @if( (unreadNotificationCount$ | async) > 0 && (hasUnreadNotifications$ |
      async)){
      <span class="number-unread">{{ unreadNotificationCount$ | async }}</span>
      }
    </p>
    @if((notifications$ | async)?.length){
    <xt-portal-button
      class="mark-as-read"
      [color]="'none'"
      [text]="t('app.labels.markAsRead')"
      [width]="'small'"
      [xTentionDummyCypress]="'notifications.menu.mark-as-read.all'"
      (clickEvent)="markAllAsRead()"
    />
    }
  </div>
  @if(loading$ | async){
  <div class="spinner-container">
    <xt-ui-kit-spinner />
  </div>
  } @else { @for(notification of notifications$ | async; track notification.id){
  <div
    class="notification-wrapper"
    role="button"
    tabindex="0"
    [attr.aria-label]="t('app.profile.notificationsHeader')"
    [xTentionDummyCypress]="'notifications.menu.mark-as-read.one'"
    (keydown.enter)="markAsRead(notification)"
    (click)="markAsRead(notification)"
  >
    <p class="text-small" [innerHTML]="notification.text"></p>
    <span class="notification-footer">
      <span class="text-and-icon">
        @if(notification.icon){
        <mat-icon [svgIcon]="notification.icon" />
        }
        <p class="text-small">{{ notification.type }}</p>
        @if(!notification.read && (hasUnreadNotifications$ | async)){
        <div class="dot"></div>
        }
      </span>
      <p class="text-small">{{ notification.time | date: 'medium' }}</p>
    </span>
  </div>
  } @if(!(notifications$ | async)?.length){
  <div class="text-small">
    {{ t('app.labels.noNotification') }}
  </div>
  } }
</div>
